import { ToastContainerProps } from 'react-toastify/dist/types';
import { StyledToastContainer } from './Toast.styles';
import {
  WarningAmber,
  ErrorOutline,
  Close,
  TaskAlt,
} from '@mui/icons-material';
import { IconProps, ToastContainer } from 'react-toastify';

const GetToastIcon: React.FC<IconProps> = ({ type }) => {
  if (type === 'error') {
    return <ErrorOutline color='error' />;
  } else if (type === 'warning') {
    return <WarningAmber color='warning' />;
  } else if (type === 'success') {
    return <TaskAlt color='success' />;
  } else if (type === 'info') {
    return <TaskAlt color='info' />;
  }
  return <ErrorOutline color='success' />;
};

const Toast: React.FC<ToastContainerProps> = (props) => {
  return (
    <StyledToastContainer>
      <ToastContainer
        autoClose={3000}
        hideProgressBar
        theme='colored'
        icon={(iconProps) => <GetToastIcon {...iconProps} />}
        closeButton={<Close fontSize='small' />}
        {...props}
      />
    </StyledToastContainer>
  );
};

export default Toast;
